import { TuiTable } from '@taiga-ui/addon-table';
import { TuiBadge } from '@taiga-ui/kit';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  output,
} from '@angular/core';

import { Subject } from 'rxjs';
import { TuiIcon, TuiButton } from '@taiga-ui/core';
import { RequestService } from '@core/services/request/request.service';
import { RequestModel } from '@core/models';
import { GroupActionsViews } from '@features/requests/request-list/types';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'x-selected-requests-group-actions-view',
  imports: [TuiButton, TuiIcon, TuiBadge, TuiTable, TranslatePipe],
  templateUrl: './selected-requests-group-actions-view.component.html',
  styleUrl: './selected-requests-group-actions-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectedRequestsGroupActionsViewComponent {
  $viewChanged = output<GroupActionsViews>({
    alias: 'viewChangedOutput',
  });
  $viewObserver = input.required<Subject<never>>({
    alias: 'viewObserver',
  });

  public readonly requestService = inject(RequestService);

  $selectedRequestsCount = this.requestService.selectedRequestsCount;
  $selectedRequests = this.requestService.selectedRequests;
  $previousView = input.required<GroupActionsViews>({ alias: 'previousView' });

  public goBack(): void {
    this.$viewChanged.emit(this.$previousView());
  }

  public removeRequest(selectedRequest: RequestModel): void {
    this.requestService.setSelectedRequestsIds({
      ...this.requestService.selectedRequestsIds(),
      [selectedRequest.id]: false,
    });

    if (this.requestService.selectedRequests().length === 0) {
      this.$viewObserver().complete();
    }
  }
}
